import { network } from 'services/network';

export const getAiRiskSummary = (params) => {
    return network.post('api/bo/chat/getAiRiskSummary', params).then((response) => {
        return response.data;
    });
};
